import { Routes, Route, Navigate } from 'react-router-dom';
import {
  LoginPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  ProtectedRoute,
} from '@/features/auth';
import {
  ProjectsListPage,
  ProjectCreatePage,
  ProjectDetailPage,
} from '@/features/projects';
import { DashboardLayout } from '@/components/layout';
import { DashboardPage } from '@/features/dashboard';
import { PhotosPage } from '@/features/photos';
import { TripsPage } from '@/features/trips';
import { ReceiptsPage } from '@/features/receipts';
import { CustomersListPage, CustomerDetailPage } from '@/features/customers';
import { SuppliersListPage, SupplierDetailPage } from '@/features/suppliers';

// Unauthorized page
function UnauthorizedPage() {
  return (
    <DashboardLayout>
      <div className="text-center py-12">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg
            className="w-8 h-8 text-red-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-secondary-900">Unauthorized</h1>
        <p className="text-secondary-600 mt-2">
          You don't have permission to access this page.
        </p>
      </div>
    </DashboardLayout>
  );
}

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      {/* Protected routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />

      {/* Project routes */}
      <Route
        path="/projects"
        element={
          <ProtectedRoute>
            <ProjectsListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects/create"
        element={
          <ProtectedRoute>
            <ProjectCreatePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects/:projectId"
        element={
          <ProtectedRoute>
            <ProjectDetailPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/photos"
        element={
          <ProtectedRoute>
            <PhotosPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/trips"
        element={
          <ProtectedRoute>
            <TripsPage />
          </ProtectedRoute>
        }
      />

      <Route
  path="/receipts"
  element={
    <ProtectedRoute>
      <ReceiptsPage />
    </ProtectedRoute>
  }
/>

      {/* Customer routes */}
      <Route
        path="/customers"
        element={
          <ProtectedRoute>
            <CustomersListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customers/:customerId"
        element={
          <ProtectedRoute>
            <CustomerDetailPage />
          </ProtectedRoute>
        }
      />

      {/* Supplier routes */}
      <Route
        path="/suppliers"
        element={
          <ProtectedRoute>
            <SuppliersListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/suppliers/:supplierId"
        element={
          <ProtectedRoute>
            <SupplierDetailPage />
          </ProtectedRoute>
        }
      />

      {/* Utility routes */}
      <Route
        path="/unauthorized"
        element={
          <ProtectedRoute>
            <UnauthorizedPage />
          </ProtectedRoute>
        }
      />

      {/* Default redirect */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;